export interface IBaseEvent {
    name: EventName;
}

export type IEvent =
    | IWindowResizedEvent
    | IUserProfileUpdatedEvent
    | IUserDepositedEvent
    | IUserWithdrewEvent
    | ILoginRequestedEvent
    | ILoginExecutedEvent
    | ILogoutRequestedEvent
    | ILogoutExecutedEvent
    | INavigatedEvent
    | IUploadDocumentKycAttemptEvent
    | IUploadDocumentKycSuccessEvent
    | IUploadDocumentKycFailedEvent
    | IRGSubmittedEvent
    | IConfigureSmsOtpExecutedEvent
    | IAuthenticateSmsOtpExecutedEvent
    | ITrustedDeviceRegisterExecutedEvent
    | IFraudBlackboxCollectedEvent
    | IFraudVerificationTriggeredEvent
    | IFraudVerificationBlockedEvent
    | IFraudVerificationAllowedEvent
    | IFraudDepositVerificationTriggeredEvent
    | IFraudDepositBlockedEvent
    | IFraudDepositAllowedEvent
    | IFraudWithdrawalVerificationTriggeredEvent
    | IFraudWithdrawalAllowedEvent
    | IFraudWithdrawalBlockedEvent;

export enum EventName {
    WINDOW_RESIZE = 'WindowResize',
    USER_PROFILE_UPDATE = 'UserProfileUpdate',
    USER_DEPOSIT = 'UserDeposit',
    USER_WITHDRAWAL = 'UserWithdrawal',
    LOGIN_REQUEST = 'LoginRequest',
    LOGIN_EXECUTED = 'LoginExecuted',
    LOGOUT_REQUEST = 'LogoutRequest',
    LOGOUT_EXECUTED = 'LogoutExecuted',
    NAVIGATE = 'Navigate',
    UPLOAD_DOCUMENT_KYC_ATTEMPT = 'UploadDocumentKycAttempt',
    UPLOAD_DOCUMENT_KYC_SUCCESS = 'UploadDocumentKycSuccess',
    UPLOAD_DOCUMENT_KYC_FAILED = 'UploadDocumentKycFailed',
    RG_SUBMITTED = 'RgSubmitted',
    CONFIGURE_SMS_OTP_EXECUTED = 'ConfigureSmsOtpExecuted',
    AUTHENTICATE_SMS_OTP_EXECUTED = 'AuthenticateSmsOtpExecuted',
    TRUSTED_DEVICE_REGISTER_EXECUTED = 'TrustedDeviceRegisterExecuted',
    FRAUD_BLACKBOX_COLLECTED = 'fraud_blackbox_collected',
    FRAUD_VERIFICATION_TRIGGERED = 'fraud_verification_triggered',
    FRAUD_DEPOSIT_VERIFICATION_TRIGGERED = 'fraud_deposit_verification_triggered',
    FRAUD_WITHDRAWAL_VERIFICATION_TRIGGERED = 'fraud_withdrawal_verification_triggered',
    FRAUD_VERIFICATION_BLOCKED = 'fraud_verification_blocked',
    FRAUD_VERIFICATION_ALLOWED = 'fraud_verification_allowed',
    FRAUD_DEPOSIT_BLOCKED = 'fraud_deposit_blocked',
    FRAUD_DEPOSIT_ALLOWED = 'fraud_deposit_allowed',
    FRAUD_WITHDRAWAL_ALLOWED = 'fraud_withdrawal_allowed',
    FRAUD_WITHDRAWAL_BLOCKED = 'fraud_withdrawal_blocked',
}

export interface IWindowResizedEvent extends IBaseEvent {
    name: EventName.WINDOW_RESIZE;
    width: number;
    height: number;
}

export interface IUserProfileUpdatedEvent extends IBaseEvent {
    name: EventName.USER_PROFILE_UPDATE;
}

export interface IUserDepositedEvent extends IBaseEvent {
    name: EventName.USER_DEPOSIT;
    amount: number;
    currency: string;
}

export interface IUserWithdrewEvent extends IBaseEvent {
    name: EventName.USER_WITHDRAWAL;
    amount: number;
    currency: string;
}

export interface ILoginRequestedEvent extends IBaseEvent {
    name: EventName.LOGIN_REQUEST;
}

export interface ILoginExecutedEvent extends IBaseEvent {
    name: EventName.LOGIN_EXECUTED;
}

export interface ILogoutRequestedEvent extends IBaseEvent {
    name: EventName.LOGOUT_REQUEST;
}

export interface ILogoutExecutedEvent extends IBaseEvent {
    name: EventName.LOGOUT_EXECUTED;
}

export interface INavigatedEvent extends IBaseEvent {
    name: EventName.NAVIGATE;
    path: string;
}

export interface IUploadDocumentKycAttemptEvent extends IBaseEvent {
    name: EventName.UPLOAD_DOCUMENT_KYC_ATTEMPT;
}

export interface IUploadDocumentKycSuccessEvent extends IBaseEvent {
    name: EventName.UPLOAD_DOCUMENT_KYC_SUCCESS;
}

export interface IUploadDocumentKycFailedEvent extends IBaseEvent {
    name: EventName.UPLOAD_DOCUMENT_KYC_FAILED;
}

export interface IRGSubmittedEvent extends IBaseEvent {
    name: EventName.RG_SUBMITTED;
    period: string;
}

export interface IConfigureSmsOtpExecutedEvent extends IBaseEvent {
    name: EventName.CONFIGURE_SMS_OTP_EXECUTED;
}

export interface IAuthenticateSmsOtpExecutedEvent extends IBaseEvent {
    name: EventName.AUTHENTICATE_SMS_OTP_EXECUTED;
}

export interface ITrustedDeviceRegisterExecutedEvent extends IBaseEvent {
    name: EventName.TRUSTED_DEVICE_REGISTER_EXECUTED;
}

export interface IFraudBlackboxCollectedEvent extends IBaseEvent {
    name: EventName.FRAUD_BLACKBOX_COLLECTED;
}

export interface IFraudVerificationTriggeredEvent extends IBaseEvent {
    name: EventName.FRAUD_VERIFICATION_TRIGGERED;
}

export interface IFraudVerificationBlockedEvent extends IBaseEvent {
    name: EventName.FRAUD_VERIFICATION_BLOCKED;
}

export interface IFraudVerificationAllowedEvent extends IBaseEvent {
    name: EventName.FRAUD_VERIFICATION_ALLOWED;
}

export interface IFraudDepositVerificationTriggeredEvent extends IBaseEvent {
    name: EventName.FRAUD_DEPOSIT_VERIFICATION_TRIGGERED;
}

export interface IFraudWithdrawalVerificationTriggeredEvent extends IBaseEvent {
    name: EventName.FRAUD_WITHDRAWAL_VERIFICATION_TRIGGERED;
}

export interface IFraudDepositBlockedEvent extends IBaseEvent {
    name: EventName.FRAUD_DEPOSIT_BLOCKED;
}

export interface IFraudDepositAllowedEvent extends IBaseEvent {
    name: EventName.FRAUD_DEPOSIT_ALLOWED;
}

export interface IFraudWithdrawalAllowedEvent extends IBaseEvent {
    name: EventName.FRAUD_WITHDRAWAL_ALLOWED;
}

export interface IFraudWithdrawalBlockedEvent extends IBaseEvent {
    name: EventName.FRAUD_WITHDRAWAL_BLOCKED;
}
